import Quill from "quill";

const Embed = Quill.import("blots/embed");

class FontAwesome extends Embed {
  static create(value) {
    let svgContent = value
    let tempEl = document.createElement('span');
    tempEl.innerHTML = svgContent;
    let svgEl = tempEl.children[0]
    svgEl.classList.add('svg-font-awesome', 'pointer-none')
    
    let node = super.create();
    const raw = svgContent.replaceAll('\n', '').replaceAll('\t', '');
    node.setAttribute("data-font-awesome", raw);
    node.appendChild(svgEl);

    return node;
  }

  static value(domNode) {
    return domNode.getAttribute("data-font-awesome")
  }
}

FontAwesome.blotName = 'font-awesome';
FontAwesome.className = 'font-awesome';
FontAwesome.tagName = 'SPAN';

export default FontAwesome;
